module.exports = __webpack_public_path__ + "img/logo-API.0d1c1cae.png";